import React from "react";
import { SvgIconsProps } from "~/common";
import SvgIcon from "@mui/material/SvgIcon";

export const Facebook2 = (props: SvgIconsProps) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M20 10.025C20 4.505 15.52 0.0249996 10 0.0249996C4.48 0.0249996 0 4.505 0 10.025C0 14.865 3.44 18.895 8 19.825V13.025H6V10.025H8V7.525C8 5.595 9.57 4.025 11.5 4.025H14V7.025H12C11.45 7.025 11 7.475 11 8.025V10.025H14V13.025H11V19.975C16.05 19.475 20 15.215 20 10.025Z"
        fill="#00382A"
      />
    </SvgIcon>
  );
};
